import React from "react";
import ContactsAction from "./Features/ContactsActions";
import { Box } from "@mui/material";

const ContactSettings = () => {
  return (
    <Box sx={{ height: "100%", display: "flex", flexDirection: "column", overflow: "hidden", width: "100%", boxSizing: "border-box" }}>
      {/* Upper Row - 15% Height with Border */}

      <Box
        sx={{
          height: "100%",
          width: "100%",
          maxWidth: "100%",
          backgroundColor: (theme) => theme.palette.background.paper,
          color: (theme) => theme.palette.text.primary,
          overflow: "hidden",
          boxSizing: "border-box",
        }}
      >
        <ContactsAction />
      </Box>
    </Box>
  );
};

export default ContactSettings;
